import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { useTranslation } from "react-i18next";

import { api } from "../../convex/_generated/api";
import { PaneHeader } from "@/components/settings/frame";
import { WorkspaceList } from "@/components/workspaces/workspace-list";

// Every workspace you're in, a new one on Studio, and joining another with a code.
export const Route = createFileRoute("/settings/workspaces")({
  component: WorkspacesPage,
});

function WorkspacesPage() {
  const { t } = useTranslation("settings");
  const plan = useQuery(api.billing.getMyPlan);
  return (
    <div>
      <PaneHeader
        title={t("nav.workspaces")}
        description={t(plan?.plan === "studio" ? "workspaces.descriptionStudio" : "workspaces.description")}
      />
      <div className="border-t border-line-strong pt-6">
        <WorkspaceList />
      </div>
    </div>
  );
}
